"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REGISTRATION_REMINDER_MAX_BATCH_INTERVAL_MS = exports.REGISTRATION_REMINDER_MIN_BATCH_INTERVAL_MS = exports.REGISTRATION_REMINDER_BATCH_INTERVAL_MS = exports.REGISTRATION_REMINDER_BATCH_SIZE = exports.REGISTRATION_REMINDER_DEFAULT_HEADING = exports.REGISTRATION_REMINDER_DEFAULT_MESSAGE = void 0;
/** Default copy for the admin re-engage blast to Pending accounts. */
exports.REGISTRATION_REMINDER_DEFAULT_MESSAGE = "You started joining Ivy but didn't finish. Come back — we're getting better every day, and it's all for you.";
/** Visible push heading shown on iOS/Android lock screens. */
exports.REGISTRATION_REMINDER_DEFAULT_HEADING = 'Ivy Dating';
/** Recipients per OneSignal request for the admin re-engage blast. */
exports.REGISTRATION_REMINDER_BATCH_SIZE = 30;
/**
 * Pause between visible re-engage batches. Longer than silent location pings
 * so a large blast to real users does not stampede OneSignal.
 */
exports.REGISTRATION_REMINDER_BATCH_INTERVAL_MS = 2000;
/** Admins may not set a shorter gap than this between re-engage batches. */
exports.REGISTRATION_REMINDER_MIN_BATCH_INTERVAL_MS = 1000;
/** Admins may not set a longer gap than this between re-engage batches. */
exports.REGISTRATION_REMINDER_MAX_BATCH_INTERVAL_MS = 30000;
//# sourceMappingURL=registration-reminder.js.map